import { MouseEvent, useContext } from 'react';

import { EntityIdAndPaginationParams } from '../../../../../../shared/models/entity-id-and-pagination-params.model';
import { ModalContext } from '../../../../../shared/components/modal/ModalContext';
import { ModalContextModel } from '../../../../../shared/components/modal/models/modal-context.model';
import useDeleteModal from '../../../../../shared/hooks/use-delete-modal/use-delete-modal';
import { ReleaseModel } from '../../../../models/release.model';
import { deleteAppRelease } from '../../../../thunks/delete-app-release.thunk';
import { getAppReleases } from '../../../../thunks/get-app-releases.thunk';

export const useGetDeleteHandler = (
  appId: number,
  data?: ReleaseModel
): ((event: MouseEvent<HTMLButtonElement>) => void) => {
  const ctx = useContext(ModalContext) as ModalContextModel;
  const deleteModal = useDeleteModal<
    ReleaseModel,
    number,
    ReleaseModel[],
    Partial<EntityIdAndPaginationParams>
  >({
    ids: data ? [data.id] : [],
    deleteAction: deleteAppRelease,
    param: { entityId: appId },
    afterDeleteAction: getAppReleases,
  });

  return (event: MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault();
    ctx.componentHandler(deleteModal);
    ctx.modalStateHandler();
  };
};
